import TripBoard from "./TripBoard";

export default TripBoard;
